<template>
  <div class="goal" :class="{'goal_full-width': fullWidth}">
    <div class="goal__container">
      <div v-if="totalKm !== -1 && currentKm !== -1">
        <h3 class="goal__title" :class="{'goal__title_full-width': fullWidth}">
          <div>
            <span class="color-success">{{ formatCurrentKm }} {{ localizedText.km ? localizedText.km : '' }}</span> <span>{{ localizedText.distance ? ' ' + localizedText.distance : '' }}</span>
          </div>
          <div>
            <Button
              variant="secondary"
              shape="circle"
              size="md"
              iconLeft="question"
              mobile
              @click="$emit('distance-question')"
            ></Button>
          </div>
        </h3>
        <div class="goal__bars">
          <div class="goal__bar goal__bar_first">
            <svg width="100%" height="34px">
              <defs>
                <mask id="myMask" x="0" y="0" width="100%" height="100%">
                  <svg width="100%" height="16" viewBox="0 0 328 16" fill="none" y="20" preserveAspectRatio="none">
                    <path 
                      d="M0.000488281 2C0.000488281 0.895431 0.895919 0 2.00049 0H328V14C328 15.1046 327.105 16 326 16H2.00049C0.895917 16 0.000488281 15.1046 0.000488281 14V2Z" 
                      fill="white"/>
                  </svg>
                  <svg width="100%" height="21" viewBox="0 0 16 20" fill="none" preserveAspectRatio="xMaxYMin meet">
                    <rect width="100%" height="21" fill="none"></rect>
                    <path 
                      d="M15.1254 1.17596e-05C15.3608 0.00383954 15.5852 0.104665 15.7493 0.280359C15.9133 0.456053 16.0036 0.692261 16.0004 0.937143V10.1821V19.0623C16.0021 19.1848 15.9803 19.3065 15.9364 19.4202C15.8925 19.5338 15.8272 19.6373 15.7445 19.7246C15.6618 19.8118 15.5633 19.8811 15.4546 19.9284C15.3459 19.9756 15.2293 20 15.1115 20C14.9937 20 14.8771 19.9756 14.7684 19.9284C14.6597 19.8811 14.5612 19.8118 14.4785 19.7246C14.3958 19.6373 14.3306 19.5338 14.2866 19.4202C14.2427 19.3065 14.221 19.1848 14.2226 19.0623V10.1821H8.21051C7.87362 10.1821 7.56649 10.3797 7.41538 10.6931L7.01781 11.52C6.86759 11.8334 6.55956 12.031 6.22268 12.031H0.889372C0.398708 12.031 0.000488281 11.6169 0.000488281 11.1065V2.78613C0.000488281 2.27581 0.398708 1.86163 0.889372 1.86163H5.12372C5.46061 1.86163 5.76775 1.66404 5.91886 1.35064L6.31643 0.52365C6.46665 0.210247 6.77467 0.0126513 7.11156 0.0126513H14.9744C15.0243 0.00397484 15.0748 -0.000253676 15.1254 1.17596e-05Z" 
                      fill="white">
                    </path>
                  </svg>
                </mask>
              </defs>
              <g mask="url(#myMask)">
                <rect width="100%" height="34" fill="rgba(1, 1, 1, 0.09)" rx="2"></rect>
                <rect :width="width1" height="34" fill="#51C41A" rx="2"></rect>
              </g>
            </svg>
            <div class="goal__captions">
              <div class="goal__caption">{{ localizedText.total ? ' ' + localizedText.total : '' }}&nbsp;</div>
              <div class="goal__caption">{{ formatTotalKm }} {{ localizedText.km ? localizedText.km : '' }}</div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="totalKm !== -1 && currentKm !== -1 && currentMoney" class="goal__divider"></div>
      <h3 v-if="currentMoney" class="goal__title" :class="{'goal__title_full-width': fullWidth}">
        <div>
          <span class="color-success" v-html="currentMoney"></span> <span>{{ localizedText.amount ? localizedText.amount : '' }}</span>
        </div>
        <div>
          <Button
            variant="secondary"
            shape="circle"
            size="md"
            iconLeft="question"
            mobile
            @click="$emit('money-question')"
          ></Button>
        </div>
      </h3>
    </div>
  </div>
</template>

<script>
import Button from '@rr-component-library/button/src/main';

export default {
  name: 'Goal',
  designVersion: '1.0.0',
  components: {
    Button,
  },
  props: {
    /**
     * Цель в км
     */
    totalKm: {
      type: Number,
      default: -1,
    },
    /**
     * Цель в км в отформатированном виде
     */
    formatTotalKm: {
      type: String,
    },
    /**
     * Сколько преодолели в км
     */
    currentKm: {
      type: Number,
      default: -1,
    },
    /**
     * Сколько преодолели в км в отформатированном виде
     */
    formatCurrentKm: {
      type: String,
    },
    /**
     * Сколько собрали денег - форматированная строка, включающая символ валюты
     */
    currentMoney: {
      type: String,
    },
    /**
     * Локализованный текст надписей
     */
    localizedText: {
      type: Object,
    },
    /**
     * Область контента на всю ширину или 1024px
     */
    fullWidth: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    width1() {
      if (!this.currentKm) {
        return 0;
      }
      return `${(this.currentKm / this.totalKm) * 100}%`;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "./Goal";
</style>
